// extracted by mini-css-extract-plugin
export var box = "CookiesPolicy-module--box--b16f8";
export var box_md = "CookiesPolicy-module--box_md--67d3c";
export var box_xmd = "CookiesPolicy-module--box_xmd--d02f3";
export var box_flex = "CookiesPolicy-module--box_flex--35f27";
export var box_lg = "CookiesPolicy-module--box_lg--c4e75";
export var box_sm = "CookiesPolicy-module--box_sm--9b66e";
export var box_outer = "CookiesPolicy-module--box_outer--e0606";
export var box_whiteBg = "CookiesPolicy-module--box_white-bg--62b43";
export var box_noMarginBottom = "CookiesPolicy-module--box_no-margin-bottom--70973";
export var box_noPadding = "CookiesPolicy-module--box_no-padding--b2210";
export var box_outerGray = "CookiesPolicy-module--box_outer-gray--817a6";
export var box_dark = "CookiesPolicy-module--box_dark--7815e";
export var box_zIndex = "CookiesPolicy-module--box_z-index--f8af0";
export var box_zIndex6 = "CookiesPolicy-module--box_z-index-6--ff4bb";
export var box_eventsWithLine = "CookiesPolicy-module--box_events-with-line--cba79";
export var box_featuresAo = "CookiesPolicy-module--box_features-ao--57725";
export var box_verticalPaddings = "CookiesPolicy-module--box_vertical-paddings--cc9a0";
export var clearP = "CookiesPolicy-module--clearP--e2839";
export var clearP_vc = "CookiesPolicy-module--clearP_vc--12d6e";
export var wrapper = "CookiesPolicy-module--wrapper--f291d";
export var hidden = "CookiesPolicy-module--hidden--10292";
export var small = "CookiesPolicy-module--small--578e3";
export var container = "CookiesPolicy-module--container--3ac2e";
export var text = "CookiesPolicy-module--text--b12f9";
export var contentWrapper = "CookiesPolicy-module--contentWrapper--c9ed1";
export var content = "CookiesPolicy-module--content--fecc7";
export var title = "CookiesPolicy-module--title--946d9";
export var button = "CookiesPolicy-module--button--259ad";
export var manageButton = "CookiesPolicy-module--manageButton--d8498";
export var showMore = "CookiesPolicy-module--showMore--cbb76";
export var withMargin = "CookiesPolicy-module--withMargin--964c7";
export var active = "CookiesPolicy-module--active--3386b";
export var fadeInAnimation = "CookiesPolicy-module--fadeInAnimation--3a0c5";
export var placeHolderShimmer = "CookiesPolicy-module--placeHolderShimmer--608ff";